import { useQuery } from "@tanstack/react-query";

import { useDomainServices } from "@/providers/DomainServices/DomainServicesContext";

export function getQueryKey(collectionId: string | undefined) {
  return ["collection", collectionId] as const;
}

export function useCollection(collectionId: string | undefined) {
  const { collections } = useDomainServices();

  return useQuery({
    queryKey: getQueryKey(collectionId),
    queryFn: ({ signal }) =>
      collections.getCollectionById(collectionId!, { abortSignal: signal }),
    enabled: Boolean(collectionId),
    staleTime: 60_000,
  });
}
